// extracted by mini-css-extract-plugin
export default {"modalDialogContainer":"ModalDialog_modalDialogContainer__PMqXC","backdrop":"ModalDialog_backdrop__CmMEB","modalDialog":"ModalDialog_modalDialog__ULvlb"};